module.exports = __webpack_public_path__ + "static/media/DocBrowser - Product Brochure 2023.09d4bf6f.pdf";